/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpisodeModel } from './EpisodeModel';
import {
    EpisodeModelFromJSON,
    EpisodeModelFromJSONTyped,
    EpisodeModelToJSON,
} from './EpisodeModel';

/**
 *
 * @export
 * @interface ListEpisodeResponse
 */
export interface ListEpisodeResponse {
    /**
     *
     * @type {number}
     * @memberof ListEpisodeResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListEpisodeResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListEpisodeResponse
     */
    total: number;
    /**
     *
     * @type {Array<EpisodeModel>}
     * @memberof ListEpisodeResponse
     */
    episodes: Array<EpisodeModel>;
}

/**
 * Check if a given object implements the ListEpisodeResponse interface.
 */
export function instanceOfListEpisodeResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('episodes' in value)) return false;
    return true;
}

export function ListEpisodeResponseFromJSON(json: any): ListEpisodeResponse {
    return ListEpisodeResponseFromJSONTyped(json, false);
}

export function ListEpisodeResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListEpisodeResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        episodes: (json['episodes'] as Array<any>).map(EpisodeModelFromJSON),
    };
}

export function ListEpisodeResponseToJSON(value?: ListEpisodeResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        episodes: (value['episodes'] as Array<any>).map(EpisodeModelToJSON),
    };
}
